import script from "./SidenavCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SidenavCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__